import { AiSuggestionReview } from '../../../index'
import { adminHttpClient } from '../../commons/adminHttpClient'

export type SaveAiDecisionRequest = {
  expenseId: string
  aiSuggestionReview: AiSuggestionReview
}

const saveAiDecision = (saveAiDecisionRequest: SaveAiDecisionRequest): Promise<any> => {
  return adminHttpClient.put('/DocReview/SaveAiDecision', {
    expenseId: saveAiDecisionRequest.expenseId,
    aiSuggestionReview: saveAiDecisionRequest.aiSuggestionReview,
  })
}

export default saveAiDecision
